"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = require("../../command-expander");
exports.cedilla = command_expander_1.lookupOrAppend({
    c: "ç"
}, "\u0327");
//# sourceMappingURL=cedilla.js.map